import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { BadgeProps } from 'Components/frameworks/badge/Badge';
import { Badge } from 'Components/frameworks/badge/Badge';
type Props = BadgeProps & {
  isOnDemand?: boolean;
};
export const AvailabilityBadge = ({ isOnDemand = false, ...rest }: Props) => (
  <Badge
    className={classnames('size-30 border-green bg-green text-white', {
      'border-orange bg-orange': isOnDemand,
    })}
    iconSize="0.875rem"
    variant="pill"
    {...rest}
    iconName={isOnDemand ? ICONS.ON_DEMAND : ICONS.ALL_INCLUSIVE}
  />
);
